import React from 'react';
import { NavLink } from 'react-router-dom';
import bnr1 from './../../images/background/bg-5.png';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

class Specialization extends React.Component {
    state = {
        services: [],
        loading: true
    };

    componentDidMount() {
        axiosClient.get(apiConfig.SERVICES.GET_ALL)
            .then(res => {
                this.setState({ services: res.data.data, loading: false });
            })
            .catch(err => {
                console.error("Error fetching services", err);
                this.setState({ loading: false });
            });
    }

    render() {
        const { services, loading } = this.state;
        const limit = this.props.limit || 3;
        const displayServices = (services || []).slice(0, limit);

        return (
            <>
                <div
                    className="section-full mobile-page-padding bg-white p-t80 p-b30 bg-repeat square_shape1"
                    style={{ backgroundImage: `url(${bnr1})` }}
                >
                    <div className="container">
                        <div className="section-content">
                            {loading ? (
                                <div className="text-center">Loading services...</div>
                            ) : (
                                <div className="row">
                                    {displayServices.map((item, index) => (
                                        <div
                                            className="col-lg-3 col-md-4 col-sm-6 m-b30"
                                            key={index}
                                        >
                                            <div className="image-effect-one hover-shadow">
                                                <img src={item.image} alt={item.name} style={{ height: '300px', objectFit: 'cover' }} />
                                                <div className="figcaption">
                                                    <p>{item.name}</p>
                                                    <NavLink
                                                        to={`/project-grid`}
                                                    >
                                                        <i className="link-plus bg-primary" />
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    <div className="col-lg-3 col-md-12 col-sm-6 m-b30">
                                        <div className="mt-box our-speciallization-content">
                                            <h3 className="m-t0">
                                                <span className="font-weight-100">
                                                    Engineering
                                                </span>
                                                <br />
                                                Reliable Systems.
                                            </h3>
                                            <p>
                                                Delivering electro-mechanical and industrial engineering solutions across Ethiopia.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="hilite-title text-right p-r50 text-uppercase text-pop-up-top">
                        <strong>Services</strong>
                    </div>
                </div>
            </>
        );
    }
}

export default Specialization;
